export const goToLogin = (navigate) => {
    navigate("/")
}
export const goToSignup = (navigate) => {
    navigate("/signup")
}
export const goToForm = (navigate) => {
    navigate("/form")
}
export const goToContactDetails = (navigate) => {
    navigate("/contactDetails")
}
export const goToTraining = (navigate) => {
    navigate("/training")
}
export const goToExperience = (navigate) => {
    navigate("/experience")
}
export const goToAbout = (navigate) => {
    navigate("/about")
}
export const goToRocket = (navigate) => {
    navigate("/rocket")
}